import __request__ from "routing/request";
export function getById(inputId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.forwarder/forwarder/input/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
